/* eslint-disable no-restricted-imports */
import {
  Button as ButtonMUI,
  ButtonProps as ButtonMuiProps,
} from '@mui/material';

export type ButtonProps = ButtonMuiProps & { to?: string; target?: '_blank' };

export const Button = (props: ButtonProps) => {
  return <ButtonMUI {...props} />;
};
